/**
 * Keeps the theme cart drawer reachable when a third-party app takes over the
 * cart trigger click.
 *
 * Rebuy SmartCart installs a click handler on the cart drawer trigger that calls
 * `preventDefault()` + `stopPropagation()`, so the theme's delegated
 * `on:click="#cart-drawer/toggle"` standard action never fires. Rebuy's own
 * overlay is hidden (see `snippets/cart-rebuy-suppress.liquid`), which left the
 * trigger doing nothing at all.
 *
 * This guard runs in the capture phase — before Rebuy's bubble-phase handler —
 * claims the click, and toggles `<theme-drawer id="cart-drawer">` directly.
 * `aria-expanded` stays in sync because `header-actions.js` reacts to the
 * drawer's own open/close events.
 *
 * Loaded as a classic script (not a module) so the listener is registered while
 * the document is still parsing, well before Rebuy's script tag is injected on
 * the window `load` event.
 */
(function () {
  var TRIGGER_SELECTOR = '[aria-controls="cart-drawer"]';
  var DRAWER_SELECTOR = 'theme-drawer#cart-drawer';

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0) return;

      var target = event.target instanceof Element ? event.target : null;
      var trigger = target && target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;

      var drawer = /** @type {HTMLElement & {toggle?: () => void}} */ (document.querySelector(DRAWER_SELECTOR));

      // Custom element not upgraded yet: leave the event alone so the theme's own
      // delegated action can still handle it.
      if (!drawer || typeof drawer.toggle !== 'function') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      drawer.toggle();
    },
    true
  );
})();
